import { __assign, __rest } from "tslib";
import { useLayoutEffect, } from 'react';
import { useFocusable } from '../../interactions/focusable';
import { setCursorToEnd } from '../../libs/dom-utils';
export function useTextField(props, inputRef) {
    var _a = props.as, elementType = _a === void 0 ? 'input' : _a, _b = props.type, type = _b === void 0 ? 'text' : _b, _c = props.autoComplete, autoComplete = _c === void 0 ? 'off' : _c, restProps = __rest(props, ["as", "type", "autoComplete"]);
    var focusableProps = useFocusable(props, inputRef).focusableProps;
    var additionalProps = {};
    if (elementType === 'input') {
        additionalProps = { type: type };
    }
    useLayoutEffect(function () {
        // By default autofocus set cursor at start position when element type is textarea.
        if (elementType === 'textarea') {
            setCursorToEnd(inputRef.current);
        }
    }, [elementType, inputRef, props.autoFocus]);
    return {
        ElementType: elementType,
        inputProps: __assign(__assign(__assign({ autoComplete: autoComplete }, restProps), focusableProps), additionalProps),
    };
}
